export type S3Region = 'ap-southeast-2' | 'us-east-1' | 'eu-central-1';

export const DEFAULT_S3_REGION: S3Region = 'ap-southeast-2';

// Keep in sync with @birdi/aws/src/s3-regions.ts (backend canonical source)
export const DATA_REGION_OPTIONS: { value: S3Region; label: string }[] = [
  { value: 'ap-southeast-2', label: 'Sydney, Australia' },
  { value: 'us-east-1', label: 'Virginia, United States' },
  { value: 'eu-central-1', label: 'Frankfurt, Europe' },
];

export interface Organisation {
  id: string;
  name: string;
  displayBranding: boolean;
  menuIcon: string;
  displayLogo: boolean;
  logo: string;
  displayEmailHeader: boolean;
  emailHeader: string;
  plan: string;
  stripeCustomerId?: string | null;
  stripeSubscriptionId?: string | null;
  seatCount?: number;
  s3Region?: S3Region;
}
